<script>
export default {
    name: "Stocklevelperstore",

    data() {

        return {
            itemsstocks: [],
            items: [],
            qtyitems: [],
            stores:[],
            itemtypes:[],
            itemstocklevel:[],
            storeSelected:false,
               
            filter: {
                date: window.moment().format('YYYY-MM-DD'),
                storeId:0,
                itemtypeId:0,
                greatorthanzero:0,
                searchFilter:'',

            },
            userName: this.$root.username,
            
            storename: '',
            selectedstore: '',
        };
    },
    watch: {
    "filter.storeId"() {
      if (!this.filter.storeId) return;
this.storename=this.stores.filter(g=>g.id==this.filter.storeId).map(g=>g.name);
      
    }},
    mounted () {

      //  this.fetchAll();
        this. getStores();
        this.getItemTypes();
        this.fetchItemStocks();
    },

    methods: {

        fetchAll () {

this.$root.loading = true;
let url=`Inventory/GetItemsStockLevelperStore?StoreId=${this.filter.storeId}`;
url += this.filter.searchFilter ? `&SearchText=${this.filter.searchFilter}` : ``;
  
this.$accountsHttp.get(url)
    .then(response => { this.itemsstocks = response.data; this.$root.loading = false; })
    .catch(() => { this.$root.loading = false; });
},  
 fetchItemStocks () {

this.$root.loading = true;
let url=`Inventory/GetItemsStockLevelForStore?StoreId=${this.filter.storeId}`;
url += `&ItemTypeId=${this.filter.itemtypeId}`
url += `&Greatorthanzero=${this.filter.greatorthanzero}` 
url += this.filter.searchFilter ? `&SearchText=${this.filter.searchFilter}` : ``; 
this.$accountsHttp.get(url)
    .then(response => { this.itemstocklevel = response.data; this.$root.loading = false; 
        if(this.filter.storeId>0)
         {
            this.storeSelected=true;
            this.selectedstore=this.storename[0];
        }
     })
    .catch(() => { this.$root.loading = false; });
},
        getItemStockLevel(ItemId,StoreId) {
 
let qtystoreitems=this.itemsstocks.itemsStore.filter(itm => itm.itemID == ItemId && itm.storeID == StoreId);
 qtystoreitems.length
                                        ?
                                       qtystoreitems[0].qty
                                        :
                                        0
 
    },
      getStores() {
            return this.$accountsHttp.get('Shared/Stores').then(response => {
                this.stores = response.data;
            }).catch(() => {});
        },
      getItemTypes() {
            return this.$accountsHttp.get('Shared/ItemTypes').then(response => {
                this.itemtypes = response.data;
            }).catch(() => {});
        },
},
}
</script>
<template>
    <tail-base-layout>
        <template v-slot:content>
            <tail-card>
                <template v-slot:card-header>
                    <h5 class="text-sm font-medium">Stock Level Per Store Report</h5>
                </template>
                <template v-slot:card-body>
                    <div class="flex w-full">
                        <div class="w-1/6 p-tiny">
                     <label for="grid-store-from" class="label-control">Search:</label> 
                   </div>  <div class="w-1/4 p-tiny">
                        <input type="text" v-model.trim="filter.searchFilter"
                     
                    id="grid-search" class="input-control input-sm text-xs">   </div>
                       
                        <div class="p-tiny">
                     <label for="grid-store-from" class="label-control">Store:</label>
                   </div> <div class="w-1/4 p-tiny">
                <tail-select>
                    <template v-slot:field>
                        <select id="grid-store-from" 
                              v-model.trim="filter.storeId"
                            class="input-control input-sm text-xs">
                            <option :value="0">Select store</option>
                            <option v-for="store in stores" 
                                :key="store.id" :value="store.id">{{ store.name }}</option>
                        </select>
                    </template>
                </tail-select>
               
            </div>
            <div class="w-1/6 p-tiny">
                     <label for="grid-store-from" class="label-control">Item Type:</label> 
                   </div> <div class="w-1/4 p-tiny">
                <tail-select>
                    <template v-slot:field>
                        <select id="grid-store-from" 
                              v-model.trim="filter.itemtypeId"
                            class="input-control input-sm text-xs">
                            <option :value="0">Select Item Type</option>
                            <option v-for="itemtype in itemtypes" 
                                :key="itemtype.id" :value="itemtype.id">{{ itemtype.type_Name }}</option>
                        </select>
                    </template>
                </tail-select>
               
            </div> 
            <div class="w-1/6 p-tiny">
                <label for="grid-status" class="label-control">Greator Than Zero
                    <input type="checkbox" v-model="filter.greatorthanzero" id="grid-status"></label>
            </div>
            
            <div class="w-1/4 p-tiny pl-2">
                            <button class="btn-sm btn-info text-xs rounded" @click.prevent="fetchItemStocks"><i class="fa fa-filter"></i> Filter</button>
                        </div>
                    </div>
                    <div class="w-full overflow-auto">
                        <!-- <table class="table table-hover">
                            <thead class="bg-blue-500 text-xs text-white">
                                <tr class="w-full flex">
                                    <th class="p-tiny w-1/6">ItemId</th>
                                    <th class="p-tiny w-1/6">ItemName</th>
                                    <th  v-for="(store, idx) in itemsstocks.stores" :key="idx"
                                        class="p-tiny flex-1">{{store.store }}</th>
                                     </tr>
                            </thead>
                            <tbody class="flex flex-col items-center text-xs bg-gray-100 overflow-auto" style="height:70vh;">
                                <tr class="flex w-full" v-for="(item, idx) in itemsstocks.items" :key="idx">
                                    <td class="p-tiny w-1/6">{{item.itemID }}</td>
                                    <td class="p-tiny w-1/6">{{ item.itemName}}</td>
                                    <td class="p-tiny flex-1" v-for="(store, idxc) in itemsstocks.stores" :key="idxc"> 
                                    
                                    {{ 
                                        itemsstocks.itemsStore.filter(itm => itm.itemID == item.itemID && itm.storeID == store.id).length
                                        ?
                                        itemsstocks.itemsStore.filter(itm => itm.itemID == item.itemID && itm.storeID == store.id)[0].qty
                                        :
                                        0
                                    }}
                                    </td>
                                </tr>
                            </tbody>
                        </table> -->
                        <table class="table table-hover">
                            <thead class="bg-blue-500 text-xs text-white">
                                <tr class="w-full flex">
                                    <th class="p-tiny w-1/6">ItemId</th>
                                    <th class="p-tiny flex-1">Item Name</th>
                                    <th class="p-tiny flex-1">Type</th>
                                     <th class="p-tiny w-1/6">Stock Level ({{selectedstore }})</th>
                                     </tr>
                            </thead>
                            <tbody class="flex flex-col items-center text-xs bg-gray-100 overflow-auto" style="height:70vh;">
                                <tr class="flex w-full" v-for="(item, idx) in itemstocklevel" :key="idx">
                                    <td class="p-tiny w-1/6">{{item.itemID }}</td>
                                    <td class="p-tiny flex-1">{{ item.itemName}}</td>
                                    <td class="p-tiny flex-1">{{ item.typeName}}</td>
                                     <td class="p-tiny w-1/6">{{ storeSelected? item.stockLevel: item.overalStockLevel}}</td>
                                    
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </template>
                <template v-slot:card-footer>
                    <div class="w-full text-right">
                      <router-link :to="{ name: `inventory-management.index` }" class="btn-sm btn-danger text-xs rounded"><i class="fa fa-caret-left"></i> Back</router-link>
                    </div>
              </template>
            </tail-card>
        </template>
    </tail-base-layout>
</template>
